import Expense from "./components/Expense";

export default Expense;
